import React from 'react'
import { mapPlayerStat, ConvertStatValue, getFullTeamName } from '../../../../Utils'
import { createUrl } from '../../../../Routing/urls'
import { CURRENT_YEAR } from '../../../../Config/League/league.config'
import { KeyMatchup } from '../../../../Api/Events/events.types'
import {
  InfoCon,
  KeyPlayerImg,
  PlayerItemCon,
  PlayerLink,
  Points,
  StatsTable,
} from '../styles'
import { colors } from '../../../../Components/consts'
import { PlayerSortKeys } from '../../../../Constant/player'

type PlayerProps = {
  player: KeyMatchup
  statList: PlayerSortKeys[]
  side: 'left' | 'right'
}

export const KeyPlayerItem: React.FC<React.PropsWithChildren<PlayerProps>> = ({
  player,
  statList,
  side,
}) => {
  const teamColor = colors.white
  const getStatValue = (stat: PlayerSortKeys) => {
    if (!player?.stats) return 0
    return player.stats[stat]
  }
  return (
    <PlayerItemCon>
      <div className="playerInfo">
        <InfoCon side={side}>
          <KeyPlayerImg src={player.profileUrl} alt="" />
          <PlayerLink
            href={createUrl('player', {
              slugName: player.slug,
              tab: 'profile',
              year: CURRENT_YEAR,
            })}
            aria-label={`${player?.firstName} ${player?.lastName} profile`}
          >
            <h3>
              {player?.firstName} {player?.lastName}
            </h3>
            <p>{`${player?.jerseyNum !== null ? `${player.jerseyNum} • ` : ''}${
              player.position
            } • ${getFullTeamName(player.teamId)}`}</p>
          </PlayerLink>
        </InfoCon>
      </div>
      <StatsTable>
        {statList.map((stat, idx) => (
          <div key={idx}>
            <Points teamColor={teamColor}>
              {ConvertStatValue(getStatValue(stat), stat)}
            </Points>
            <p className="statText">{mapPlayerStat(stat)}</p>
          </div>
        ))}
      </StatsTable>
    </PlayerItemCon>
  )
}
